import * as React from "react";
import classnames from "classnames";
import getConfig from "next/config";
import { FooterTrustedShops } from "@grandvisionhq/analytics";
import { MediaQuery, Logo, Accordion, AccordionItem, RichTextArea } from "@grandvisionhq/common";
import { Newsletter } from "@grandvisionhq/content";
import { Container, Heading } from "@grandvisionhq/elements";
import { parseHtml } from "@grandvisionhq/lib-utils-html";
import { FooterAppLinks } from "./FooterAppLinks.js";
import { FooterPaymentOptions } from "./FooterPaymentOptions.js";
import { FooterSocialLinks } from "./FooterSocialLinks.js";
/* empty css            */
const Footer = ({
  appLinks,
  additionalContent,
  paymentOptionLogos,
  socialMediaLinks,
  content: contentSections,
  socialTitle,
  title,
  logo,
  disclaimer,
  siteName,
  newsletterProps,
  hasNewsletterV2,
  children
}) => {
  const { publicRuntimeConfig } = getConfig();
  const isSmallScreen = MediaQuery.useIsBelow(MediaQuery.BreakpointName.TABLET_LANDSCAPE);
  const footerSections = React.useMemo(
    () => contentSections?.map((section, index) => ({
      id: section.id || `footer-section-${index}`,
      title: section.title,
      body: section.body.value
    })) || [],
    [contentSections]
  );
  const logoTitle = siteName ? `${siteName} home` : "Home";
  if (!contentSections) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(
    "footer",
    {
      className: classnames("footer", { "footer--no-border": hasNewsletterV2 }),
      role: "contentinfo"
    },
    /* @__PURE__ */ React.createElement(Container, null, logo?.url && /* @__PURE__ */ React.createElement("div", { className: "footer__top" }, /* @__PURE__ */ React.createElement(Logo, { className: "footer__logo", url: "/", image: logo, title: logoTitle })), title && /* @__PURE__ */ React.createElement(Heading, { variant: "small", component: "div", className: "footer__title" }, title), /* @__PURE__ */ React.createElement("div", { className: "footer__content" }, isSmallScreen ? /* @__PURE__ */ React.createElement(Accordion, { className: "footer__accordion" }, footerSections.map((item) => /* @__PURE__ */ React.createElement(
      AccordionItem,
      {
        key: item.id,
        id: item.id,
        label: item.title,
        headingLevel: "div",
        fullWidth: true
      },
      /* @__PURE__ */ React.createElement(RichTextArea, { className: "footer__rich-text", content: item.body })
    ))) : /* @__PURE__ */ React.createElement("div", { className: "footer__sections" }, footerSections.map((footerSection) => /* @__PURE__ */ React.createElement("section", { className: "footer-section", key: footerSection.id }, /* @__PURE__ */ React.createElement(Heading, { variant: "smallest", component: "div", className: "footer-section__title" }, parseHtml(footerSection.title)), /* @__PURE__ */ React.createElement("div", { className: "footer-section__content" }, /* @__PURE__ */ React.createElement(RichTextArea, { className: "footer__rich-text", content: footerSection.body }))))), /* @__PURE__ */ React.createElement("section", { className: "footer__aside" }, publicRuntimeConfig.trustedShops && publicRuntimeConfig.trustedShops.id && /* @__PURE__ */ React.createElement(
      FooterTrustedShops,
      {
        divCSS: {
          textAlign: "center"
        }
      }
    ), /* @__PURE__ */ React.createElement(FooterSocialLinks, { title: socialTitle, items: socialMediaLinks }), appLinks && /* @__PURE__ */ React.createElement(FooterAppLinks, { items: appLinks }), newsletterProps && /* @__PURE__ */ React.createElement(Newsletter, { ...newsletterProps, variant: "modal" }), additionalContent && /* @__PURE__ */ React.createElement("div", { className: "footer__additional-content" }, parseHtml(additionalContent.html)))), paymentOptionLogos && /* @__PURE__ */ React.createElement(FooterPaymentOptions, { items: paymentOptionLogos }), children, disclaimer && /* @__PURE__ */ React.createElement("div", { className: "footer__legal" }, parseHtml(disclaimer.html)))
  );
};
export {
  Footer,
  Footer as default
};
//# sourceMappingURL=Footer.js.map
